import { FormGroup, FormParagraph } from '@ksyos/design-system';

type HolterAdviceQuestionReadOnlyProps = {
    adviceQuestion?: string;
};

export function HolterAdviceQuestionReadOnly({ adviceQuestion }: HolterAdviceQuestionReadOnlyProps) {
    if (!adviceQuestion) {
        return null;
    }

    return (
        <FormGroup label="Adviesvraag">
            <FormParagraph>{adviceQuestion}</FormParagraph>
        </FormGroup>
    );
}
